import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;

export const DrawerOverlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  background-color: transparent;
`;

export const DrawerContainer = styled.div<{ $isOpen: boolean; $isClosing: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 600px;
  max-width: 90vw;
  background-color: #ffffff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  animation: ${({ $isOpen, $isClosing }) => {
    if ($isClosing) return slideOut;
    if ($isOpen) return slideIn;
    return 'none';
  }} 200ms ease-out;
  transform: ${({ $isOpen, $isClosing }) => ($isOpen && !$isClosing ? 'translateX(0)' : 'translateX(100%)')};
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  flex-shrink: 0;
`;

export const DrawerHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const DrawerContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0.1rem 1.5rem 1rem;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background-color: transparent;
  color: var(--p-color-icon);
  cursor: pointer;
  transition: all 150ms ease;

  &:hover {
    background-color: var(--p-color-bg-surface-hover);
    color: var(--p-color-icon-hover);
  }

  &:active {
    background-color: var(--p-color-bg-surface-active);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const InsightCard = styled.div<{ $borderColor?: string }>`
  padding: 0.75rem 1rem;
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid ${({ $borderColor }) => ($borderColor ? `${$borderColor}66` : 'var(--p-color-border-secondary)')};
  transition: all 150ms ease;

  &:hover {
    border-color: ${({ $borderColor }) => ($borderColor ? `${$borderColor}66` : 'var(--p-color-border)')};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }
`;
